/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_ZH_CN: Record<string, string> = {
    ariaAnnounceChart: '图表，共有${seriesCount}[number]个系列',
    ariaAnnounceFlowProportionLink: '链接 ${index} 总共 ${count}，从 ${from} 到 ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: '节点 ${index} 之 ${count}, ${description}',
    ariaAnnounceGaugeChart: '仪表盘图表, ${caption}',
    ariaAnnounceHierarchyChart: '层次图表, ${caption}',
    ariaAnnounceHierarchyDatum: '级别 ${level}[number], ${count}[number] 子项, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: '按空格键或回车键切换可见性',
    ariaLabelAddHorizontalLine: '添加水平线',
    ariaLabelAnnotationOptionsToolbar: '注释选项',
    ariaLabelAnnotationSettingsDialog: '注释设置',
    ariaLabelColorPicker: '颜色选择器',
    ariaLabelFinancialCharts: '财务图表',
    ariaLabelLegend: '图例',
    ariaLabelLegendItem: '${label}, 图例项 ${index}[number] / ${count}[number]',
    ariaLabelLegendItemUnknown: '未知图例项目',
    ariaLabelLegendPageNext: '下一页图例',
    ariaLabelLegendPagePrevious: '上一传奇页面',
    ariaLabelLegendPagination: '图例分页',
    ariaLabelNavigator: '导航器',
    ariaLabelNavigatorMaximum: '最大值',
    ariaLabelNavigatorMinimum: '最小值',
    ariaLabelNavigatorRange: '范围',
    ariaLabelRangesToolbar: '范围',
    ariaLabelSettingsTabBar: '设置',
    ariaLabelZoomToolbar: '缩放',
    ariaValuePanRange: '${min}[percent0to2dp] 至 ${max}[percent0to2dp]',
    contextMenuDownload: '下载',
    contextMenuPanToCursor: '平移到此处',
    contextMenuToggleOtherSeries: '切换其他系列',
    contextMenuToggleSeriesVisibility: '切换可见性',
    contextMenuZoomToCursor: '缩放到此处',
    dialogHeaderChannel: '频道',
    dialogHeaderDatePriceRange: '日期和价格',
    dialogHeaderDateRange: '日期范围',
    dialogHeaderFibonacciRange: '斐波那契回撤',
    dialogHeaderLine: '线',
    dialogHeaderPriceRange: '价格范围',
    dialogHeaderText: '文字',
    dialogInputAlign: '对齐',
    dialogInputColorPicker: '颜色',
    dialogInputColorPickerAltText: '文字颜色',
    dialogInputExtendAbove: '扩展以上',
    dialogInputExtendBelow: '向下扩展',
    dialogInputExtendChannelEnd: '扩展通道终点',
    dialogInputExtendChannelStart: '延长通道开始',
    dialogInputExtendLeft: '向左延伸',
    dialogInputExtendLineEnd: '延长线端',
    dialogInputExtendLineStart: '延长线起点',
    dialogInputExtendRight: '向右延伸',
    dialogInputFibonacciBands: '波段',
    dialogInputFibonacciBandsAltText: '斐波那契波段',
    dialogInputFillColorPicker: '填充',
    dialogInputFillColorPickerAltText: '填充颜色',
    dialogInputFontSize: '大小',
    dialogInputFontSizeAltText: '字体大小',
    dialogInputLineStyle: '虚线',
    dialogInputPosition: '位置',
    dialogInputReverse: '反转',
    dialogInputShowFill: '显示填充',
    dialogInputStrokeWidth: '‘粗细’',
    dialogInputStrokeWidthAltText: '‘线条粗细’',
    iconAltTextAlignCenter: '居中',
    iconAltTextAlignLeft: '居左',
    iconAltTextAlignRight: '右对齐',
    iconAltTextClose: '‘关闭’',
    iconAltTextLineStyleDashed: '长虚线',
    iconAltTextLineStyleDotted: '短虚线',
    iconAltTextLineStyleSolid: '实线',
    iconAltTextPositionBottom: '底部',
    iconAltTextPositionCenter: '居中',
    iconAltTextPositionTop: '顶部',
    inputTextareaPlaceholder: '添加文字',
    measurerDateRangeBars: '${value}[number] 条',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: '体积 ${value}',
    overlayLoadingData: '正在加载数据...',
    overlayNoData: '没有数据显示',
    overlayNoVisibleSeries: '没有可见的系列',
    overlayUnsupportedBrowser: '不兼容的浏览器版本。请升级您的浏览器。',
    seriesHistogramTooltipCount: '${yName} (计数)',
    seriesHistogramTooltipFrequency: '频率',
    seriesHistogramTooltipMean: '${yName} (平均值)',
    seriesHistogramTooltipSum: '${yName} (总和)',
    toolbarAnnotationsArrow: '箭头',
    toolbarAnnotationsArrowDown: '箭头向下',
    toolbarAnnotationsArrowUp: '向上箭头',
    toolbarAnnotationsCallout: '标注',
    toolbarAnnotationsClearAll: '清除所有',
    toolbarAnnotationsComment: '评论',
    toolbarAnnotationsDatePriceRange: '日期和价格',
    toolbarAnnotationsDateRange: '日期范围',
    toolbarAnnotationsDelete: '删除',
    toolbarAnnotationsDisjointChannel: '独立通道',
    toolbarAnnotationsDragHandle: '“拖动工具栏”',
    toolbarAnnotationsFibonacciAnnotations: '斐波那契',
    toolbarAnnotationsFibonacciRetracement: '斐波那契回撤',
    toolbarAnnotationsFibonacciRetracementTrendBased: '基于趋势的斐波纳契',
    toolbarAnnotationsFillColor: '填充颜色',
    toolbarAnnotationsHorizontalLine: '水平线',
    toolbarAnnotationsLineAnnotations: '趋势线',
    toolbarAnnotationsLineColor: '线条颜色',
    toolbarAnnotationsLineStrokeWidth: '线条宽度',
    toolbarAnnotationsLineStyle: '线条样式',
    toolbarAnnotationsLock: '锁定',
    toolbarAnnotationsMeasurerAnnotations: '测量工具',
    toolbarAnnotationsNote: '注释',
    toolbarAnnotationsParallelChannel: '平行通道',
    toolbarAnnotationsPriceRange: '价格范围',
    toolbarAnnotationsQuickDatePriceRange: '测量',
    toolbarAnnotationsSettings: '设置',
    toolbarAnnotationsShapeAnnotations: '箭头',
    toolbarAnnotationsText: '文本',
    toolbarAnnotationsTextAnnotations: '文本标注',
    toolbarAnnotationsTextColor: '字体颜色',
    toolbarAnnotationsTextSize: '文字大小',
    toolbarAnnotationsTrendLine: '趋势线',
    toolbarAnnotationsUnlock: '解锁',
    toolbarAnnotationsVerticalLine: '垂直线',
    toolbarRange1Month: '1个月',
    toolbarRange1MonthAria: '1个月',
    toolbarRange1Year: '1年',
    toolbarRange1YearAria: '1年',
    toolbarRange3Months: '3个月',
    toolbarRange3MonthsAria: '3个月',
    toolbarRange6Months: '6月',
    toolbarRange6MonthsAria: '6个月',
    toolbarRangeAll: '全部',
    toolbarRangeAllAria: '全部',
    toolbarRangeYearToDate: '年初至今',
    toolbarRangeYearToDateAria: '年初至今',
    toolbarSeriesTypeCandles: '蜡烛图',
    toolbarSeriesTypeDropdown: '图表类型',
    toolbarSeriesTypeHighLow: '高低',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: '空心蜡烛',
    toolbarSeriesTypeLine: '线',
    toolbarSeriesTypeLineWithMarkers: '带标记的折线图',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: '阶梯线',
    toolbarZoomPanEnd: '移至结尾',
    toolbarZoomPanLeft: '向左移动',
    toolbarZoomPanRight: '向右平移',
    toolbarZoomPanStart: '平移到开始位置',
    toolbarZoomReset: '重置缩放',
    toolbarZoomZoomIn: '放大',
    toolbarZoomZoomOut: '缩小',
    tooltipPaginationStatus: '${index}[number] / ${count}[number]',
};
